export default __webpack_public_path__ + "static/media/ContentCopyIcon.03e88cef.svg";